import { useCallback, useContext, useState } from "react";
import { buildFcmPayload } from "global/functions/fbNotifications";
import { _developerFcm } from "project/appConfiguration";
import { useFunctions } from "./useFunctions";

export const _fcmTopicKeys = {
  generic: 'XIbIQe4rhWJn5qDRBnI4',
  error: 'me_app_error',
  auth: 'me_app_auth',
}

export const useFcm = () => {

  const { fn_cls } = useFunctions()

  const [fcmResponse, setFcmResponse] = useState()

  const cb = (result, fcmPayload) => { setFcmResponse({ result, fcmPayload }) }

  const sendFcm_payload = useCallback((payload) => {
    fn_cls && fn_cls.sendFcmPayload(payload, null, cb)
  }, []);

  const sendFcm_toToken = useCallback((tokenKey, title, body) => {
    const _payload = buildFcmPayload([tokenKey], _fcmTopicKeys.error, title, body)
    fn_cls && fn_cls.sendFcmPayload(_payload, null, cb)
  }, []);

  const sendFcm_toTopic = useCallback((topic, title, body) => {
    const _payload = buildFcmPayload(null, topic, title, body)
    fn_cls && fn_cls.sendFcmPayload(_payload, null, cb)
  }, []);

  const sendFcm_errorTopic = useCallback((title, body) => {
    const _payload = buildFcmPayload([_developerFcm], _fcmTopicKeys.error, title, body)
    fn_cls && fn_cls.sendFcmPayload(_payload, null, cb)
  }, []);

  const sendFcm_authTopic = useCallback((user) => {
    const { email, displayName } = user ?? {}
    switch (email) {
      case 'philipaokeeffe@gmail.com':
        break;
      default:
        const title = 'Auth Changed'
        const body = `${displayName} (${email}) has logged in.`
        const _payload = buildFcmPayload([_developerFcm], _fcmTopicKeys.auth, title, body)
        fn_cls && fn_cls.sendFcmPayload(_payload, null, cb)
    }
  }, []);

  return {
    fcmResponse,
    sendFcm_payload,
    sendFcm_toTopic,
    sendFcm_toToken,
    sendFcm_errorTopic,
    sendFcm_authTopic
  };
};
